export default __webpack_public_path__ + "static/media/solution_52.fd2dee12.svg";